export { SIGNUP_URL } from '../engagement/engagementContent';

export const engagementSaasHero = {
  imageSrc:
    'https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=1600&h=900&fit=crop&q=85',
  imageAlt: 'Modern SaaS team workspace with soft natural light',
};

export const whatKolanutDoesSaasFeatures = [
  {
    tag: 'Account health',
    headline: 'See who\'s slipping.',
    body: 'Connect your product. Kolanut shows which accounts are active, at risk, never activated, or gone quiet.',
    imageSrc:
      'https://images.unsplash.com/photo-1551434678-e076c223a692?w=900&h=700&fit=crop&q=80',
    imageAlt: 'SaaS team working at laptops',
    overlayType: 'health',
    overlayHealth: {
      title: 'How your accounts are doing',
      rows: [
        { label: 'Active', count: 14, pct: 40, bar: 'bg-emerald-500', track: 'bg-emerald-50' },
        { label: 'At risk', count: 7, pct: 20, bar: 'bg-orange-500', track: 'bg-orange-50' },
        { label: 'Churned', count: 9, pct: 26, bar: 'bg-red-500', track: 'bg-red-50' },
        { label: 'Never activated', count: 5, pct: 14, bar: 'bg-amber-400', track: 'bg-amber-50' },
      ],
    },
  },
  {
    tag: 'Outreach',
    headline: 'Reach them before they leave.',
    body: 'Kolanut drafts email and WhatsApp for each group. People who stalled in setup. Accounts that went quiet. Customers already on the edge.',
    imageSrc:
      'https://images.unsplash.com/photo-1518531933037-91b2f5f229cc?w=900&h=700&fit=crop&q=80',
    imageAlt: 'Soft green foliage',
    overlayType: 'inbox',
    overlayInbox: {
      title: 'Drafts ready for you',
      rows: [
        { initial: 'A', color: 'bg-orange-500', name: 'At risk', subject: 'Usage dropped this week', snippet: 'Save email ready' },
        { initial: 'N', color: 'bg-amber-500', name: 'Never activated', subject: 'Signed up, never came back', snippet: 'Check-in drafted' },
        { initial: 'C', color: 'bg-rose-500', name: 'Churned', subject: 'Cancelled last month', snippet: 'Win-back queued' },
        { initial: 'L', color: 'bg-sky-500', name: 'Low usage', subject: 'No login in 12 days', snippet: 'Nudge drafted' },
        { initial: 'T', color: 'bg-violet-500', name: 'Trial ending', subject: 'Trial ends in 2 days', snippet: 'Upgrade ready' },
        { initial: 'P', color: 'bg-emerald-500', name: 'Power users', subject: 'Hit the usage limit', snippet: 'Expansion queued' },
      ],
    },
  },
  {
    tag: 'Approvals',
    headline: 'Nothing sends until you say so.',
    body: 'Open a draft, edit it, and approve. Kolanut waits. Your customers hear from you, not a black box.',
    imageSrc:
      'https://images.unsplash.com/photo-1497215728101-856f4ea42174?w=900&h=700&fit=crop&q=80',
    imageAlt: 'Minimal bright office with plants',
    overlayType: 'chat',
    overlayChat: [
      { role: 'kolanut', text: '4 drafts ready for at-risk accounts. Want them sent as is, or should I hold for edits?' },
      { role: 'customer', text: 'Send the first two. Hold the rest so I can tweak the offer.' },
      { role: 'kolanut', text: 'Sent. The other two are waiting in Approvals.' },
      { role: 'customer', text: 'Rewrite the win-back one. Softer on the discount.' },
      { role: 'kolanut', text: 'Updated. Ready when you are.' },
      { role: 'customer', text: 'Looks good. Send it.' },
    ],
  },
  {
    tag: 'Results',
    headline: 'Know what brought people back.',
    body: 'See opens, clicks, and who signed in after each campaign. You know which accounts came back and which still need you.',
    imageSrc:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=900&h=700&fit=crop&q=80',
    imageAlt: 'Person walking outdoors in soft light',
    overlayType: 'summary',
    overlaySummary: {
      title: 'Today from Kolanut',
      lines: [
        '12 at-risk emails sent',
        '3 accounts signed in after',
        '2 never activated users came back',
        '5 save offers approved',
        '1 expansion play queued',
        '8 check-in drafts waiting',
        '4 meetings booked from outreach',
      ],
    },
  },
];

export const saasBenefits = [
  {
    metric: '+20-30%',
    label: 'retention',
    detail: 'More accounts stay active after trial and first renewal.',
  },
  {
    metric: 'Higher NRR',
    label: 'from expansion',
    detail: 'Kolanut spots upgrade moments in usage that are easy to miss.',
  },
  {
    metric: 'Your time',
    label: 'back for product',
    detail: 'You approve outreach. You keep shipping.',
  },
];

export const saasTestimonials = [
  {
    quote:
      'Onboarding nudges, churn saves, and expansion prompts run without us living in Customer.io.',
    name: 'Elena R.',
    role: 'Head of Growth, B2B SaaS',
  },
  {
    quote:
      'It feels like adding customer success capacity on day one. It catches slipping accounts before renewal week panic.',
    name: 'David K.',
    role: 'Co-founder, PLG startup',
  },
  {
    quote:
      'Our NRR improved in the first quarter. It watches usage signals and queues the right play before we lose the account.',
    name: 'Sarah T.',
    role: 'VP Marketing, vertical SaaS',
  },
];

export const saasIntegrations = [
  { name: 'Gmail', logo: '/integrations/gmail.png' },
  { name: 'Supabase', logo: '/integrations/supabase.svg' },
  { name: 'Firebase', logo: '/integrations/firebase.svg' },
  { name: 'Clerk', logo: '/integrations/clerk.svg' },
  { name: 'Neon', logo: '/integrations/neon.svg' },
  { name: 'PostHog', logo: '/integrations/posthog.svg' },
  { name: 'WhatsApp', logo: '/integrations/whatsapp.svg' },
  { name: 'Stripe', logo: '/integrations/stripe.svg' },
  { name: 'HubSpot', logo: '/integrations/hubspot.svg' },
  { name: 'Slack', logo: '/integrations/slack.svg' },
  { name: 'Google Analytics', logo: '/integrations/googleanalytics.svg' },
];
